module.exports = __webpack_public_path__ + "img/Balkon01.cb6dd19c.jpg";